if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.endTime = this.parseEndDate(this.getAttribute('data-end'));
        this.values = {
          days: this.querySelector('[data-unit="days"]'),
          hours: this.querySelector('[data-unit="hours"]'),
          mins: this.querySelector('[data-unit="mins"]'),
          secs: this.querySelector('[data-unit="secs"]'),
        };
        this.timerEl = this.querySelector('[data-countdown-timer]');
        this.expiredEl = this.querySelector('[data-countdown-expired]');
        this.labelEl = this.querySelector('[data-countdown-label]');

        if (!this.endTime || isNaN(this.endTime)) return;

        this.update();
        this.interval = setInterval(this.update.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      // Accepts "YYYY-MM-DD HH:MM" or "YYYY-MM-DD" (browser-local time), or any Date-parseable string.
      parseEndDate(value) {
        if (!value) return null;
        const normalized = value.trim().replace(' ', 'T');
        return new Date(normalized).getTime();
      }

      update() {
        const diff = this.endTime - Date.now();

        if (diff <= 0) {
          this.showExpired();
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const mins = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;

        this.setValue(this.values.days, days, false);
        this.setValue(this.values.hours, hours);
        this.setValue(this.values.mins, mins);
        this.setValue(this.values.secs, secs);
      }

      setValue(el, num, pad = true) {
        if (!el) return;
        el.textContent = pad ? String(num).padStart(2, '0') : String(num);
      }

      showExpired() {
        if (this.interval) clearInterval(this.interval);
        if (this.timerEl && this.expiredEl) {
          this.timerEl.setAttribute('hidden', '');
          this.expiredEl.removeAttribute('hidden');
          // The "starts in" lead-in no longer applies once the sale is live.
          if (this.labelEl) this.labelEl.setAttribute('hidden', '');
        }
      }
    }
  );
}
